import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ConfigService } from '../../../config/data-services/config.abstract.data-service';

@Injectable({ providedIn: 'root' })
export class UrlBuilderService {
    constructor(private readonly config: ConfigService<any>) {}

    public buildDetailUrl(detailUrl: string): Observable<string> {
        if (detailUrl) {
            const baseUrl: Observable<string> = this.config.getConfig().pipe(
                map(config => config.baseUrl),
                map(baseUrl => baseUrl?.slice(0, -1) + detailUrl),
                map(value => value ?? ''),
                shareReplay()
            );

            return baseUrl;
        }

        return of('');
    }

    public buildDetailUrlArray(detailUrls: string[]): Observable<string[]> {
        if (detailUrls) {
            const baseUrl: Observable<string[]> = this.config.getConfig().pipe(
                map(config => config.baseUrl),
                map(baseUrl => detailUrls.map(detailUrl => baseUrl?.slice(0, -1) + detailUrl)),
                map(value => value ?? ['']),
                shareReplay()
            );

            return baseUrl;
        }

        return of(['']);
    }
}
